import React, {Component} from 'react';
import {Box} from "../shapes/Box";
// import {Canvas} from "@react-three/fiber";

class ThreeDLayout extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
          <div id="baseStd2">
            {/* <Canvas>
              <ambientLight />
              <pointLight position={[10, 10, 10]} />
              <Box position={[-1.2, 0, 0]} />
              <Box position={[1.2, 0, 0]} />
            </Canvas> */}
              <div className="row mainContent">
                  {this.props.children}
              </div>
          </div>
        );
    }
}

export default ThreeDLayout;
